import { materials as MaterialsService } from '@coligo-org/fe-common/services';
import { ErrorsActions } from '../error';
import logger from '../../../common/services/logService';
import { coursesTypes } from '../../reducers/types';

export const deleteCommentStart = () => ({
  type: coursesTypes.UPDATE_MATERIAL_START,
});

export const deleteCommentEnd = () => ({
  type: coursesTypes.UPDATE_MATERIAL_END,
});

export default ({ noteId, commentId, callback }) =>
  async dispatch => {
    try {
      dispatch(deleteCommentStart());
      await MaterialsService.deleteNoteComment({ noteId, commentId });
      if (callback) await callback();
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(deleteCommentEnd());
    }
  };
